import service from "@/libs/service";
import Vue from "vue";

export const namespaced = true;

export const state = {
    list: [],
    used: []
};

export const mutations = {
    SET_DISCOUNT_LIST(state, list) {
        state.list = list;
    },
    SET_DISCOUNT_USED(state, used) {
        state.used = used;
    }
};

export const actions = {
    payment({ commit }, params) {
        return new Promise((resolve, reject) => {
            service
                .request("/accounts/payment", params)
                .then(response => {
                    resolve();
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    updatePayments({ commit }, payment) {
        return new Promise((resolve, reject) => {
            service
                .request("/accounts/update/payments", payment)
                .then(response => {
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    deletePayment({ commit }, paymentId) {
        return new Promise((resolve, reject) => {
            service
                .request("/accounts/delete/payments", { paymentId })
                .then(response => {
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    updateBucket({ commit }, bucket) {
        return new Promise((resolve, reject) => {
            service
                .request("/accounts/update/bucket", payment)
                .then(response => {
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    async getPayments({ commit }, { start, end }) {
        try {
            return await service.request(`/accounts/payments?start=${start}&end=${end}`);
        } catch (error) {
            console.error("Error: ", error);
            throw error;
        }
    },
    discounts({ commit }) {
        return new Promise((resolve, reject) => {
            service
                .request("/accounts/discount/list")
                .then(response => {
                    commit("SET_DISCOUNT_LIST", response.list);
                    commit("SET_DISCOUNT_USED", response.used);
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    createDiscount({ commit }, discount) {
        return new Promise((resolve, reject) => {
            service
                .request("/accounts/discount/create", { discount: { ...discount } })
                .then(response => {
                    commit("SET_DISCOUNT_LIST", response.list);
                    commit("SET_DISCOUNT_USED", response.used);
                    resolve();
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    removeDiscount({ commit }, item) {
        return new Promise((resolve, reject) => {
            service
                .request("/accounts/discount/remove", {
                    discount: {
                        code: item.code,
                        sort: item.sort
                    }
                })
                .then(response => {
                    commit("SET_DISCOUNT_LIST", response.list);
                    commit("SET_DISCOUNT_USED", response.used);
                    resolve();
                })
                .catch(err => {
                    reject(err);
                });
        });
    }
};

export const getters = {
    getDiscountsList(state) {
        return state.list;
    },
    getDiscountsUsed(state) {
        return state.used;
    }
};

export default {
    state,
    mutations,
    actions,
    getters
};
